<template>
    <component v-bind="$attrs" :is="tagName" :class="classes" :disabled="modDisabled" @click="clicked">
        <div v-if="!!$slots.icon" class="kl-ol-map-tools-action__svg-icon">
            <slot name="icon" />
        </div>
        <vl-icon v-if="icon" :icon="icon" class="kl-ol-map-tools-action__icon" />
        <span class="kl-ol-map-tools-action__text">{{ a11yLabel }}</span>
    </component>
</template>
<script src="./kl-ol-map-tools-action.ts"></script>
